export default __webpack_public_path__ + "static/media/subirS.09889679.png";